module.exports = __webpack_public_path__ + "assets/img/tx21g_3.3efaa591.jpg";